// DeadlineChip — application-deadline countdown chip.
//
// Shared by MatchRow (auto-extracted closes_at) and CV Writer (the
// user's manually-entered deadline) so the "Closes in N days" / "Closed
// N days ago" wording + urgency colours live in ONE place.
//
// Color-coded by urgency (future only):
//   ≤ 3 days → red    ·  ≤ 7 days → amber  ·  > 7 days → green
//   past     → grey "Closed N d ago" (informational)
//
// Days are computed against the user's local clock; the date is plain
// YYYY-MM-DD (treated as local midnight) so rounding by 24h is fine.

export function daysUntil(dateStr: string): number | null {
  const t = Date.parse(dateStr);
  if (!Number.isFinite(t)) return null;
  return Math.floor((t - Date.now()) / (1000 * 60 * 60 * 24));
}

export default function DeadlineChip({ date }: { date?: string | null }) {
  if (!date) return null;
  const days = daysUntil(date);
  if (days == null) return null;
  const isPast = days < 0;
  const n = Math.abs(days);
  const label = isPast
    ? (n === 0 ? 'Closed today' : `Closed ${n}d ago`)
    : (days === 0 ? 'Closes today' : `Closes in ${days}d`);

  let bg = 'rgba(110,110,110,0.08)';
  let fg = 'var(--ink2)';
  if (!isPast) {
    if (days <= 3)      { bg = 'rgba(180,58,58,0.10)';  fg = '#a13030'; }   // red
    else if (days <= 7) { bg = 'rgba(170,140,30,0.10)'; fg = '#8a6f1c'; }   // amber
    else                { bg = 'rgba(40,120,60,0.10)';  fg = '#1f6f3a'; }   // green
  }
  return (
    <span
      className="chip"
      style={{ fontSize: 10.5, padding: '2px 7px', background: bg, color: fg }}
      title={`Application deadline: ${date}`}
    >
      {label}
    </span>
  );
}
